export default __webpack_public_path__ + "static/bloom-bdeadf6c0a0a395927e9b51c38ca9c7c.png";